const BLACKLIST = {
  PAGE_TITLE: 'Black List | Raychat',

  HEADING_TITLE: 'Black List',
  HEADING_SUBTITLE: 'Blocked users are displayed in this list.',

  MORE_INFO: 'More Information',
  DELETE_ALL_FROM_BLACK_LIST: 'Remove All From Black List',
  DELETE_FROM_BLACK_LIST: 'Remove From Black List',
  DELETE_FROM_BLACK_LIST_CONFIRM:
    'Do you confirm that this user should be removed from the blacklist?',
  NO_BLOCKED_USER: 'No blocked user exist',

  CONFIRM_MODAL_CANCEL: 'Cancel',
  CONFIRM_MODAL_CONFIRM: 'Confirm',

  REMOVE_ALL_CONFIRM_TEXT:
    'Are you sure you want to remove all blocked users from blacklist?',
};

export default BLACKLIST;
